module.exports = __webpack_public_path__ + "static/img/zxzx-B4CqnfDV.348d850.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/zxzx-B4CqnfDV.png
// module id = tevj
// module chunks = 16